import { render, staticRenderFns } from "./received-order-input-inquiry.vue?vue&type=template&id=967df23e&scoped=true&"
import script from "./received-order-input-inquiry.vue?vue&type=script&lang=js&"
export * from "./received-order-input-inquiry.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "967df23e",
  null
  
)

export default component.exports